<div class="form-group">
    <div class="row fields-group">
        <div class="col-auto">
            <label class="input-label">{{ 'dets.predicate_value' | translate }}</label>
        </div>
        <div class="col">
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" class="custom-control-input"
                   name="booleanValue" id="booleanValueTrue" required
                   [checked]="booleanValue === true"
                   (change)="booleanValueChanged(true)">
                <label class="custom-control-label" for="booleanValueTrue">{{'dets.boolean_true' | translate}}</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" class="custom-control-input"
                   name="booleanValue" id="booleanValueFalse" required
                   [checked]="booleanValue === false"
				   (change)="booleanValueChanged(false)">
                <label class="custom-control-label" for="booleanValueFalse">{{'dets.boolean_false' | translate}}</label>
            </div>
            
            <label class="input-label mt-2 d-block">{{ 'dets.comparison_field_label' | translate }}</label>
            <search-select *ngIf="fields.length > 0"
                    (change)="onTargetFormFieldKeyChange($event)"
                    [items]="fields"
                    [selected]="sourceFormFieldKey"
                    [placeholder]="'Choose here' | translate"></search-select>
        </div>
    </div>
</div>
